import React from "react";
import { useSelector } from "react-redux";
import './OutstandingSummary.css';

const OutstandingSummary = () => {
  const { GetCustMaster } = useSelector(
    (state) => state.CustomerMaster
  );

  const customer = GetCustMaster?.getCustomerMasters?.[0];
console.log("customer",customer);

  const {
    balance,
    aged30Days,
    aged45Days,
    aged60Days,
    agedMoreThan60Days,
    lastPaymentAmount,
    lastPaymentDate,
    creditLimit,
  } = customer;

  // const overDue30 = aged45Days + aged75Days + agedMoreThan75Days;
  // const overDue60 = aged75Days + agedMoreThan75Days;

  const formatCurrency = (value) =>
    value?.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
    });

  return (
    <div className="card border-0 outstanding-summary-card">
      <div className="card-body">
        <h6 className="card-title fw-semibold mb-2">
          Outstanding Summary
        </h6>

        <div className="row g-1 mt-1">
          <SummaryItem
            label="Current Outstanding"
            value={formatCurrency(balance)}
          />
          <SummaryItem
            label="Balance Outstanding (0-30) days"
            value={formatCurrency(aged30Days)}
          />
          <SummaryItem
            label="Balance Outstanding (31-45) days"
            value={formatCurrency(aged45Days)}
          />
          <SummaryItem
            label="Balance Outstanding (46-60) days"
            value={formatCurrency(aged60Days)}
          />
          <SummaryItem
            label="Balance Outstanding 60+ Days"
            value={formatCurrency(agedMoreThan60Days)}
          />
          <SummaryItem
            label="Last Payment Value"
            value={formatCurrency(lastPaymentAmount)}
          />
          <SummaryItem
            label="Last Payment Date"
            value={lastPaymentDate}
          />
          <SummaryItem
            label="Credit Limit"
            value={formatCurrency(creditLimit)}
          />
        </div>
      </div>
    </div>
  );
};

const SummaryItem = ({ label, value }) => (
  <div className="col-12">
    <div className="d-flex justify-content-between align-items-center p-2 bg-light rounded">
      <span className="os-label">{label}</span>
      <span className="os-value">{value}</span>
    </div>
  </div>
);

export default OutstandingSummary;
